import classNames from "classnames";
import React, { FC, HTMLProps } from "react";
import styled, { css } from "styled-components";
import { deprecationWarning } from "./utils/warning";

const DEFAULT_TAG = "p";
const PARAGRAPH_MAX_WIDTH = "600px";

export type TextProps = {
  /**
   * @deprecated Use `Heading` component instead.
   */
  type?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "small" | "label";
  inverted?: boolean;
  isAllCaps?: boolean;
  className?: string;
  secondary?: boolean;
  tertiary?: boolean;
};

const TextElement = styled.div<{ as: React.ElementType }>`
  ${({ as }) =>
    (as === "p" || as === "small") &&
    css`
      display: block; // needed for 'small' tag
      max-width: ${PARAGRAPH_MAX_WIDTH};
    `}
`;

export const Text: FC<TextProps & HTMLProps<HTMLElement>> = (props) => {
  const {
    inverted, // eslint-disable-line @typescript-eslint/naming-convention
    isAllCaps,
    children,
    type = DEFAULT_TAG,
    ...eltProps
  } = props;
  const isSecondary = !!props.secondary;
  const isTertiary = !!props.tertiary;

  if (type.startsWith("h")) {
    deprecationWarning(`<Text type="${type}" ... />`, `<Heading level="${type}" ... />`);
  }

  const classes = classNames({
    "do-inverted": inverted,
    "do-secondary": isSecondary,
    "do-tertiary": isTertiary,
    "do-all-caps": !!isAllCaps || type === "h5",
  });

  if (classes) {
    if (!eltProps.className) {
      eltProps.className = "";
    }
    eltProps.className += " " + classes;
  }

  // eslint-disable-next-line
  const { secondary, tertiary, ...restEltProps } = eltProps;

  return (
    <TextElement as={type as React.ElementType} {...restEltProps}>
      {children}
    </TextElement>
  );
};
